import React from 'react';
import { NoteMinor } from '@shopify/polaris-icons';

function UploadedFile(props: any){

  const { file } = props;

  const calcFileSize = (size: any) => {
    let sizeStr;
    if (size > 10000000000) {
      sizeStr = `> 999GB`;
    } else if (size > 10000000) {
      sizeStr = `${Math.round(size/10000000)}GB`;
    } else if (size > 10000) {
      sizeStr = `${Math.round(size/10000)}MB`;
    } else if (size > 1000) {
      sizeStr = `${Math.round(size/1000)}MB`;
    } else {
      sizeStr = `${size}B`
    }
    return sizeStr;
  }

  return file && (
    <div className="uploaded-file">
      <NoteMinor/>
      <span className="uploaded-file__name">{file.name}</span>
      <span className="uploaded-file__size">{calcFileSize(file.size)}</span>
    </div>
  );
}

export default UploadedFile;